import './RadioButton.scss';

import React, { useContext } from 'react';
import { get, set } from 'lodash';

import { NCRContext } from 'views';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormLabel from 'react-bootstrap/FormLabel';

import BootstrapSwitchButton from 'bootstrap-switch-button-react';

import { InputLabel } from 'components/form/prototypes'

const RadioButton = ({ name, label, value, callback, disabled }) => {

  const { state, setState } = useContext(NCRContext);

  const defaultValue = get(state, name) || '';
  const defaultCallback = (value) => setState(state => ({ ...set(state, name, value) }));

  return (
    <>
      {
        disabled ?
          <InputLabel
            value={((value || defaultValue) && 'Yes') || 'No'}
            label={label}
            disabled
            className={'text-center'} />
          :
          <Row className={'mb-2'}>
            <Col className={'my-auto'}>
              <FormLabel className={'my-auto'}>{`${label}:`}</FormLabel>
            </Col>
            <Col>
              <BootstrapSwitchButton
                checked={value || defaultValue}
                onstyle={'warning'}
                name={name}
                onlabel='Yes'
                offlabel='No'
                onChange={value => callback ? callback(value) : defaultCallback(value)}
              />
            </Col>
          </Row>
      }
    </>
  )
}

export { RadioButton };
